import CryptoJS from "crypto-js";

// La ventana de pago de Banorte (VCE) llama a "onSuccess" cuando termina el flujo, aunque
// el banco NO haya aprobado el cobro (tarjeta declinada, codigo 3D Secure incorrecto...).
// Lo que distingue un cobro aprobado es "resultadoPayw": "A" = aprobado; cualquier otro
// valor ("N", "D"...) = no se cobro. Segun el caso llega de dos formas (verificado el 2026-10-13):
//
//  1) En claro, cuando falla antes de procesar (ej. codigo 3D Secure incorrecto):
//     {"status3D":"423","eci":"00","id":2,"message":"Codigo incorrecto, solicita uno nuevo.",
//      "numeroControl":"...","resultadoPayw":"N"}
//
//  2) CIFRADO dentro de "data", cuando Banorte proceso la transaccion (aprobada o no):
//     {"data":"<base64>","status3D":"200","eci":"05","id":2,"message":"operationSuccessfully",...}
//     Al descifrarlo (con vi/salt/passphrase que entrega la API de pagos) queda, por ejemplo:
//     {"idAfiliacion":8916724,"referencia":140866372569,"numeroControl":"...","resultadoPayw":"A",
//      "resultadoAut":"00","codigoAut":"006437","texto":"Aprobado","bancoEmisor":"BANORTE",...}
//
// Cifrado segun el manual "Ventana de Comercio Electronico Cifrada v1.7", Anexo B:
// AES/CTR/NoPadding, llave de 16 bytes con PBKDF2 (1000 vueltas, SHA1).
export function descifrarRespuestaVCE(textoCifradoBase64, { vi, salt, passphrase }) {
  const llave = CryptoJS.PBKDF2(passphrase, CryptoJS.enc.Hex.parse(salt), {
    keySize: 128 / 32,
    iterations: 1000,
  });
  const descifrado = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(textoCifradoBase64) },
    llave,
    { iv: CryptoJS.enc.Hex.parse(vi), mode: CryptoJS.mode.CTR, padding: CryptoJS.pad.NoPadding }
  );
  return descifrado.toString(CryptoJS.enc.Utf8);
}

const vacio = (valor) => valor === undefined || valor === null || String(valor).trim() === "";

// Regresa { aprobado, desconocido, motivo, detalle }.
// "desconocido" = no se pudo saber el resultado (respuesta de una forma nueva o fallo al
// descifrar): en ese caso aprobado = true para conservar el comportamiento anterior y no
// perder un pago real; quien llama debe dejar un aviso en la consola.
export function evaluarRespuestaVCE(respuesta, claves) {
  const r = respuesta && typeof respuesta === "object" ? respuesta : {};
  let resultado = r.resultadoPayw;
  let detalle = null;

  if (vacio(resultado) && typeof r.data === "string" && claves && claves.vi && claves.salt && claves.passphrase) {
    try {
      detalle = JSON.parse(descifrarRespuestaVCE(r.data, claves));
      resultado = detalle && detalle.resultadoPayw;
    } catch (error) {
      return { aprobado: true, desconocido: true, motivo: "", detalle: null, error: error.message };
    }
  }

  if (vacio(resultado)) {
    return { aprobado: true, desconocido: true, motivo: "", detalle };
  }
  if (String(resultado).trim().toUpperCase() === "A") {
    return { aprobado: true, desconocido: false, motivo: "", detalle };
  }

  const texto = detalle && typeof detalle.texto === "string" && detalle.texto.trim() ? detalle.texto.trim() : "";
  const mensaje = typeof r.message === "string" && r.message.trim() ? r.message.trim() : "";
  return { aprobado: false, desconocido: false, motivo: texto || mensaje || "Banorte no aprobó el pago", detalle };
}
